<template>
  <div class="qr-code-button-outside" :class="isWhatsapp ? 'whatsapp' : 'default'">
    <a :href="link" target="_blank">
      <img :src="require(`@/assets/${variant}.svg`)" :alt="title" />
      {{ title }}
    </a>

    <div class="d-flex justify-center pt-4">
      <qrcode-vue class="qr-code" :value="link" :size="76" level="L" />
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
export default {
  name: 'QrCodeButton',
  components: { QrcodeVue },
  props: {
    variant: {
      type: String,
      default: '',
      validator: value => ['playstore', 'apple', 'whatsapp'].includes(value)
    },
    link: {
      type: String,
      default: ''
    }
  },
  computed: {
    title() {
      const variants = {
        playstore: 'Google Play',
        apple: 'App Store',
        whatsapp: 'WhatsApp'
      }

      return variants[this.variant]
    },
    isWhatsapp() {
      return this.variant === 'whatsapp'
    }
  }
}
</script>

<style lang="scss" scoped>
.qr-code-button-outside {
  height: 154px;
  width: 154px;
  border: 2px solid;
  border-radius: 26px 26px 22px 22px;
}

a {
  width: 100%;
  padding: 12px 20px;
  border-radius: 22px;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  line-height: 1;
  text-decoration: none;
}

.default {
  border-color: #000;
  a {
    color: #fff !important;
    background: #000 !important;
  }
}

.whatsapp {
  border-color: #0fc94d !important;
  a {
    background: #0fc94d;
    color: #1d1919 !important;
  }
}

@media screen and (max-width: 768px) {
  .qr-code-button-outside {
    border: 0px;
    height: 44px;
    .qr-code {
      display: none;
    }
  }
}
</style>
